module.exports = __webpack_public_path__ + "img/logo-title.656a9f2c.png";